import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { loadState, reset } from "./localStorage";
import {
  ACTION_LOGIN,
  ACTION_LOGOUT,
  SESSION_TOKEN,
  UPDATE_USER_NAME,
  EVENT,
  LOCALE_LANGUAGE,
} from "@mainaction";
import { APP_API_KEY } from "@constant";
import {
  specList,
  vehicleList,
  editNumberplate,
  locationList,
  serviceList,
} from "@numberplatereducer";
import { badgeList } from "@badgesreducer";
import { myProfile, changePassword } from "@personalinforeducer";
import {
  packageList,
  walletList,
  purchaseHistory,
  openRecharge,
  transactionList,
  myBalance,
  conversionRate,
} from "@transactionreducer";

var loginReducer = (state = true, action) => {
  // need to change it to false
  state = loadState();

  if (state == undefined) {
    state = {
      isLoggedIn: false,
    };
  }

  if (action.type === ACTION_LOGIN) {
    state.isLoggedIn = action.payload;
  }

  if (action.type === ACTION_LOGOUT) {
    state.isLoggedIn = action.payload;
  }

  return state.isLoggedIn;
};

var tokensReducer = (state = {}, action) => {
  state = loadState();

  if (state == undefined || state.session == undefined) {
    state = {
      session: {
        apiKey: APP_API_KEY,
        sessionToken: "",
        userid: "",
        udfid: "",
        username: "",
        email: "",
        usertype: "",
      },
    };
  }

  if (action.type === SESSION_TOKEN) {
    if (action.payload.session_token) {
      state.session.sessionToken = action.payload.session_token;
      state.session.userid = action.payload.userid;
      state.session.udfid = action.payload.dfid;
      state.session.username = action.payload.username;
      state.session.email = action.payload.email;
      state.session.usertype = action.payload.usertype;
    }
  }

  if (action.type === UPDATE_USER_NAME) {
    state.session.username = action.payload.username;
  }

  if (action.type === ACTION_LOGOUT) {
    state.session.sessionToken = "";
    state.session.userid = "";
    state.session.udfid = "";
    state.session.username = "";
    state.session.email = "";
    state.session.usertype = "";
    reset();
  }

  return state.session;
};

var eventData = (state = {}, action) => {
  if (action.type === EVENT) {
    return action.payload;
  }
  return state;
};

var localeLanguage = (state = "nl", action) => {
  if (action.type === LOCALE_LANGUAGE) {
    state = action.payload;
  }

  return state;
};

const rootReducer = combineReducers({
  form: formReducer,
  isLoggedIn: loginReducer,
  session: tokensReducer,
  eventData,

  // Numberplates
  specList,
  vehicleList,
  editNumberplate,
  locationList,
  serviceList,
  //Badge
  badgeList,
  //Personal Info
  myProfile,
  changePassword,

  //Package
  packageList,
  walletList: walletList,
  openRecharge: openRecharge,
  purchaseHistory: purchaseHistory,
  transactionList: transactionList,
  myBalance: myBalance,
  conversionRate: conversionRate,
  localeLanguage: localeLanguage,
});

// const rootReducer = (state, action) => {
//   if (action.type === "ACTION_LOGOUT") {
//     return appReducer(undefined, action);
//   }

//   return appReducer(state, action);
// };

export default rootReducer;
